import { CSSProperties, useMemo, useState } from "react";
import { HexColorPicker, HexColorInput } from "react-colorful";
import classNames from "classnames";
import Button from "react-bootstrap/Button";
import { resources } from "@constants/hardcoded-strings";
import styles from "./color-picker-container.less";

type ColorPickerContainerProps = {
    controlId: string;
    initialColor: string;
    position: "top" | "bottom";
    onClickSave: (newValue: string) => void;
    onClickCancel: () => void;
};

export const ColorPickerContainer = (props: ColorPickerContainerProps) => {
    const { initialColor, position, controlId, onClickSave, onClickCancel } = props;

    const [color, setColor] = useState(initialColor);

    const handleSaveClick = () => {
        onClickSave(color);
    };

    const colorPickerContainerPositionClassName = useMemo(() => {
        return position === "top" ? styles.topColorPickerContainer : styles.bottomColorPickerContainer;
    }, [position]);

    const colorSwatchStyle: CSSProperties ={ 
        backgroundColor: color
    };

    return (
        <div className={classNames(styles.colorPickerContainer, colorPickerContainerPositionClassName)}>
            <div className={styles.colorPickerColorContainer}>
                <HexColorPicker className={styles.colorPicker} color={color} onChange={setColor} />
            </div>
            <div className={styles.colorPickerInputContainer}>
                <span className={styles.colorPickerInputLabel}>Hex:</span>
                <HexColorInput prefixed={true} className={styles.colorPickerInput} color={color} onChange={setColor} />
                <div className={styles.colorSwatch} style={colorSwatchStyle} />
            </div>
            <div className={styles.buttonContainer}>
                <Button id={`${controlId}-cancel-button`} onClick={onClickCancel} variant={"outline-secondary"}>{resources.common.buttons.cancel.label}</Button>
                <Button id={`${controlId}-submit-button`} onClick={handleSaveClick} variant={"primary"}>{resources.common.buttons.update.label}</Button>
            </div>
        </div>
    );
};